import React, { Component } from 'react';
import config from 'react-global-configuration';

import { BrowserRouter, Redirect, Route, Link } from 'react-router-dom';
import RequestApi from '../Miscelania/RequestApi';

// Importação do Bootstrap
import { Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';

import { BR, GY } from 'country-flag-icons/react/3x2'

const PropTypes = require('prop-types');

class Topo extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      language: false,
      user: ''
    };

    this.logout = this.logout.bind(this);
    this.changeLanguage = this.changeLanguage.bind(this);

    this.locale = getLocale();
  }

  componentDidMount () {
    var self = this;
    if (localStorage.getItem("data") !== null) {
      this.setState({user: JSON.parse(localStorage.getItem("data")).email})
    } else {
      localStorage.removeItem("cid");
      this.context.router.history.push('/usuario/login');
    }

    if (localStorage.getItem("lang") !== null) {
      this.setState({language: localStorage.getItem("lang")});
    } else {
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/usuario/idioma', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({language: responseJson.data.default_lang});
          localStorage.setItem("lang", responseJson.data.default_lang);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  logout(e) {
    e.preventDefault();
    localStorage.removeItem("cid");
    this.context.router.history.push('/usuario/login');
  }

  changeLanguage(e) {
    var current_language = localStorage.getItem("lang");
    var new_language = 'pt-BR';
    if(current_language === 'pt-BR') new_language = 'en-US';
    this.setState({language: new_language});
    localStorage.setItem("lang", new_language);

    var header = this.refs.request_api.header('application/json');
    var self = this;
    var datasave = {
      language: new_language,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/usuario/idioma', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        window.location.reload();
      }).catch((error) => {
        console.error(error);
      });
    });
  
  }

  render() {

    return (
      <div>
        <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
        {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
        <section id="top">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-md-6" id="top-infs">
                {this.locale.Layout.Topo.bemVindo} {this.state.user} - <Link to={'/usuario/nova/senha'}>{this.locale.Layout.Topo.botaoMinhaConta}</Link>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<Link to={'/usuario/login'} onClick={this.logout}>{this.locale.Layout.Topo.botaoSair}</Link>
              </div>
              <div className="col-xs-12 col-md-6 text-right" id="top-infs">
              </div>
            </div>
          </div>
        </section>
        <section id="header">
          <Navbar collapseOnSelect>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to={'/'}><img src={config.get('cdn') + '/images/logo1.png'} style={{width: '100%'}} alt="SIGVOOS" /></Link>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav>
                <NavDropdown eventKey={1} title={this.locale.Layout.Topo.menuCadastros.tituloMenu} id="menu-cadastro">
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.Bases}</MenuItem>
                  <MenuItem href={'/bases'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeBases}</MenuItem>
                  <MenuItem href={'/base/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarBases}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Tipos de Intervenção de Manutenção</MenuItem>
                  <MenuItem href={'/manutencao/intervencoes'} className="menu-links">Lista de Tipos de Intervenção de Manutenção</MenuItem>
                  <MenuItem href={'/manutencao/intervencao/cadastrar'} className="menu-links">Cadastrar Tipo de Intervenção de Manutenção</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.Aeronaves}</MenuItem>
                  <MenuItem href={'/aeronaves'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeAeronaves}</MenuItem>
                  <MenuItem href={'/aeronave/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarAeronaves}</MenuItem>
                  <MenuItem href={'/aeronave/modelos'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeModelosDeAeronaves}</MenuItem>
                  <MenuItem href={'/aeronave/modelo/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarModelosDeAeronave}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.Cargos}</MenuItem>
                  <MenuItem href={'/cargos'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeCargos}</MenuItem>
                  <MenuItem href={'/cargo/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarCargos}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.Designacoes}</MenuItem>
                  <MenuItem href={'/designacoes'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeDesignacoes}</MenuItem>
                  <MenuItem href={'/designacao/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarDesignacoes}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.ComposicaoDaCabine}</MenuItem>
                  <MenuItem href={'/experiencia/minima/editar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ExperienciaMinima}</MenuItem>
                  <MenuItem href={'/incompatibilidades'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.IncompatibilidadesDeTripulantes}</MenuItem>
                  <MenuItem href={'/funcionario/graduacoes'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.GraduacoesDeTripulantes}</MenuItem>
                  <MenuItem href={'/funcionario/copilotos/autorizacoes'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CopilotosAutorizadosComando}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.OcorrenciaisAnormais}</MenuItem>
                  <MenuItem href={'/ocorrencias/anormais'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeOcorrenciasAnormais}</MenuItem>
                  <MenuItem href={'/ocorrencia/anormal/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarOcorrenciaAnormal}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.FuncoesDeBordo}</MenuItem>
                  <MenuItem href={'/funcoes/bordo'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeFuncoesDeBordo}</MenuItem>
                  <MenuItem href={'/funcao/bordo/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarFuncaoDeBordo}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.Locais}</MenuItem>
                  <MenuItem href={'/locais'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeLocais}</MenuItem>
                  <MenuItem href={'/local/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarLocal}</MenuItem>
                  <MenuItem href={'/tipos/local'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeTiposDeLocal}</MenuItem>
                  <MenuItem href={'/tipo/local/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarTipoDeLocal}</MenuItem>
                  <MenuItem href={'/operadores'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeOperadores}</MenuItem>
                  <MenuItem href={'/operador/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarOperador}</MenuItem>
                  <MenuItem href={'/controladores'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeResponsaveisPeloEspacoAereo}</MenuItem>
                  <MenuItem href={'/controlador/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarResponsavelPeloEspacoAereo}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.TiposDeVoo}</MenuItem>
                  <MenuItem href={'/tipos/voo'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeTiposDeVoo}</MenuItem>
                  <MenuItem href={'/tipo/voo/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarTipoDeVoo}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuEscalas.Contratos}</MenuItem>
                  <MenuItem href={'/contratos'} className="menu-links">{this.locale.Layout.Topo.menuEscalas.ListaDeContratos}</MenuItem>
                  <MenuItem href={'/contrato/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuEscalas.CadastrarContratos}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuEscalas.Clientes}</MenuItem>
                  <MenuItem href={'/clientes'} className="menu-links">{this.locale.Layout.Topo.menuEscalas.ListaDeClientes}</MenuItem>
                  <MenuItem href={'/cliente/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuEscalas.CadastrarClientes}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.FornecedoresDeCombustivel}</MenuItem>
                  <MenuItem href={'/fornecedores/combustivel'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ListaDeFornecedores}</MenuItem>
                  <MenuItem href={'/fornecedor/combustivel/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.CadastrarFornecedores}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuCadastros.Petrobras}</MenuItem>
                  <MenuItem href={'/referencias/ptbr'} className="menu-links">{this.locale.Layout.Topo.menuCadastros.ReferenciasPTBR}</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={2} title={this.locale.Layout.Topo.menuFuncionarios.tituloMenu} id="menu-colaboradores">
                  <MenuItem header>{this.locale.Layout.Topo.menuFuncionarios.Colaboradores}</MenuItem>
                  <MenuItem href={'/colaboradores/todos'} className="menu-links">{this.locale.Layout.Topo.menuFuncionarios.ListaDeColaboradores}</MenuItem>
                  <MenuItem href={'/colaboradores/ativos'} className="menu-links">{this.locale.Layout.Topo.menuFuncionarios.ListaDeColaboradoresAtivos}</MenuItem>
                  <MenuItem href={'/funcionarios/sem/cargo'} className="menu-links">{this.locale.Layout.Topo.menuFuncionarios.ListagemDeFuncionariosSemCargo}</MenuItem>
                  <MenuItem href={'/funcionario/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuFuncionarios.Cadastrar}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuFuncionarios.Controles}</MenuItem>
                  <MenuItem href={'/tripulantes/pesquisa/habilitacoes'} className="menu-links">{this.locale.Layout.Topo.menuFuncionarios.PesquisaDeHabilitacoes}</MenuItem>
                  <MenuItem href={'/tripulantes/designacoes'} className="menu-links">{this.locale.Layout.Topo.menuFuncionarios.ListaDeTripulantesPorDesignacao}</MenuItem>
                  <MenuItem href={'/tripulantes/aso/eletrocadiograma/vencimento'} className="menu-links">{this.locale.Layout.Topo.menuFuncionarios.VencimentoDeASOEEletrocardiograma}</MenuItem>
                  <MenuItem href={'/tripulantes/senioridade'} className="menu-links">{this.locale.Layout.Topo.menuFuncionarios.Senioridade}</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={3} title={this.locale.Layout.Topo.menuVoos.tituloMenu} id="menu-voos">
                  <MenuItem header>{this.locale.Layout.Topo.menuVoos.Relatorios}</MenuItem>
                  <MenuItem href={'/relatorios/voo'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ListaDeRelatoriosDeVoo}</MenuItem>
                  <MenuItem href={'/relatorio/voo/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuVoos.CadastrarRelatorioDeVoo}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuVoos.Abastecimentos}</MenuItem>
                  <MenuItem href={'/abastecimentos'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ListaDeAbastecimentos}</MenuItem>
                  <MenuItem href={'/abastecimento/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuVoos.CadastrarAbastecimentoAvulso}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuVoos.EscalaDiaria}</MenuItem>
                  <MenuItem href={'/escalas/programacao'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ListaDeEscalasDiaria}</MenuItem>
                  <MenuItem href={'/escala/programacao/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuVoos.CadastrarEscala}</MenuItem>
                  <MenuItem href={'/disponibilidade/tripulantes'} className="menu-links">{this.locale.Layout.Topo.menuVoos.DisponibilidadeDeTripulantes}</MenuItem>
                  <MenuItem href={'/simular/escala/programacao'} className="menu-links">{this.locale.Layout.Topo.menuVoos.SimularEscalaDiaria}</MenuItem>
                  <MenuItem href={'/aeronaves/movimentacao/mensal'} className="menu-links">{this.locale.Layout.Topo.menuVoos.MovimentacaoDeAeronavesMensal}</MenuItem>
                  <MenuItem href={'/aeronaves/movimentacao/anual'} className="menu-links">{this.locale.Layout.Topo.menuVoos.MovimentacaoDeAeronavesAnual}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuVoos.ReboqueDeAeronave}</MenuItem>
                  <MenuItem href={'/reboque/aeronaves'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ConsultarReboques}</MenuItem>
                  <MenuItem href={'/reboque/aeronave/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuVoos.CadastrarReboques}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuVoos.Indisponibilidade}</MenuItem>
                  <MenuItem href={'/indisponibilidade/aeronaves'} className="menu-links">{this.locale.Layout.Topo.menuVoos.AeronavesIndisponiveis}</MenuItem>
                  <MenuItem href={'/indisponibilidades'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ListaDeIndisponibilidades}</MenuItem>
                  <MenuItem href={'/indisponibilidades/arquivadas'} className="menu-links">{this.locale.Layout.Topo.menuVoos.IndisponibilidadesArquivadas}</MenuItem>
                  <MenuItem href={'/indisponibilidade/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuVoos.CadastrarIndisponibilidade}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuVoos.Alertas}</MenuItem>
                  <MenuItem href={'/alertas'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ListaDeAlertas}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuVoos.Controles}</MenuItem>
                  <MenuItem href={'/contrato/consulta'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ConsultaContratos}</MenuItem>
                  <MenuItem href={'/tripulantes/pesquisa/voos'} className="menu-links">{this.locale.Layout.Topo.menuVoos.VisualizarHoraDeVoo}</MenuItem>
                  <MenuItem href={'/relatorio/voo/pesquisa'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ControleGeralDeRelatorios}</MenuItem>
                  <MenuItem href={'/relatorio/voo/xml/bloco'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ExtratoDeXMLEmBloco}</MenuItem>
                  <MenuItem href={'/relatorio/voo/db/bloco'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ExtratoDeDBEmBloco}</MenuItem>
                  <MenuItem href={'/relatorio/voo/main/bloco'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ExtratoDeRelatoriosEmBloco}</MenuItem>
                  <MenuItem href={'/relatorio/voo/aeronaves/contratadas'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ControleDiarioDeUtilizacaoDeAeronavesContratadas}</MenuItem>
                  <MenuItem href={'/relatorio/voo/quantidade'} className="menu-links">{this.locale.Layout.Topo.menuVoos.QuantidadeDeVoosPorDia}</MenuItem>
                  <MenuItem href={'/relatorio/voo/abastecimento'} className="menu-links">{this.locale.Layout.Topo.menuVoos.RelatorioDeAbastecimentos}</MenuItem>
                  <MenuItem href={'/relatorio/voo/consumo'} className="menu-links">{this.locale.Layout.Topo.menuVoos.RelatorioDeConsumo}</MenuItem>
                  <MenuItem href={'/relatorio/voo/consumo/disponibilidade'} className="menu-links">{this.locale.Layout.Topo.menuVoos.RelatorioDeDisponibilidadeDeCombustivel}</MenuItem>
                  <MenuItem href={'/relatorio/voo/tripulantes'} className="menu-links">{this.locale.Layout.Topo.menuVoos.RelatorioDeHorasGeradasPorTipoDeCargo}</MenuItem>
                  <MenuItem href={'/relatorio/voo/destinos'} className="menu-links">{this.locale.Layout.Topo.menuVoos.RelatorioDePousosPorLocalidade}</MenuItem>
                  <MenuItem href={'/relatorio/voo/pousos'} className="menu-links">{this.locale.Layout.Topo.menuVoos.RelatorioDeTempoEmSolo}</MenuItem>
                  <MenuItem href={'/relatorio/voo/carga/externa'} className="menu-links">{this.locale.Layout.Topo.menuVoos.RelatorioDeVoosComCargaExterna}</MenuItem>
                  <MenuItem href={'/relatorio/voo/diferenca/trechos'} className="menu-links">{this.locale.Layout.Topo.menuVoos.RelatorioDeTempoEntreTrechos}</MenuItem>
                  <MenuItem href={'/relatorio/voo/consulta/indisponibilidade'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ConsultaDeIndisponibilidade}</MenuItem>
                  <MenuItem href={'/relatorio/voo/boletim/disponibilidade'} className="menu-links">{this.locale.Layout.Topo.menuVoos.BoletimDeDisponibilidade}</MenuItem>
                  <MenuItem href={'/relatorio/voo/apuracao/horas'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ApuracaoDeHoras}</MenuItem>
                  <MenuItem href={'/relatorio/voo/conferencia/medicao'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ConferenciaDeMedicao}</MenuItem>
                  <MenuItem href={'/controle/experiencia/noturna'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ControleDeExperienciaNoturna}</MenuItem>
                  <MenuItem href={'/controle/tarifas'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ControleDeTarifas}</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={4} title="eDB" id="menu-edb">
                  <MenuItem header>Diário de Bordo</MenuItem>
                  <MenuItem href={'/aeronave/diario/dashboard'} className="menu-links">Dashboard</MenuItem>
                  <MenuItem href={'/aeronave/diarios'} className="menu-links">Lista de diários de bordo</MenuItem>
                  <MenuItem href={'/aeronave/diario/cadastrar'} className="menu-links">Cadastrar diário de bordo</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>ACR</MenuItem>
                  <MenuItem href={'/aeronave/diario/acrs/abertos'} className="menu-links">Lista de ACRs abertos</MenuItem>
                  <MenuItem href={'/aeronave/diario/acrs/fechados'} className="menu-links">Lista de ACRs encerrados</MenuItem>
                </NavDropdown>
              </Nav>
              <Nav pullRight>
                <NavDropdown eventKey={21} title={<i className="fa fa-cog fa-fw"></i>} id="menu-usuarios">
                  <MenuItem header>{this.locale.Layout.Topo.menuConfiguracoes.UsuariosDoSistema}</MenuItem>
                  <MenuItem href={'/usuarios'} className="menu-links">{this.locale.Layout.Topo.menuConfiguracoes.ListaDeUsuarios}</MenuItem>
                  <MenuItem href={'/usuario/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuConfiguracoes.CadastrarUsuario}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuConfiguracoes.Emails}</MenuItem>
                  <MenuItem href={'/emails'} className="menu-links">{this.locale.Layout.Topo.menuConfiguracoes.ListaDeEnderecoDeEmails}</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>{this.locale.Layout.Topo.menuConfiguracoes.Diversos}</MenuItem>
                  <MenuItem href={'/links/uteis'} className="menu-links">{this.locale.Layout.Topo.menuConfiguracoes.LinksUteis}</MenuItem>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </section>
        {
          config.get('development') &&
          <section className="development" style={{padding: '20px', background: '#ffcccb', color: 'red', width: '100%', marginBottom: '20px', fontSize: '20px'}}>
            <i className="fa fa fa-warning"></i><span style={{color: 'red'}}> {this.locale.Layout.Topo.atencaoVoceEstaUtilizandoOAmbienteDeHomologacao} </span><i className="fa fa fa-warning"></i>
          </section>
        }
      </div>
    );
  }
}

Topo.contextTypes = {
  router: React.PropTypes.object.isRequired
}


export default Topo;



// WEBPACK FOOTER //
// ./src/Components/Layout/Topo.js